import { UsersApi } from "@/api/users";
import { DeleteUserRequest } from "@/api/users/types";
import { useUIStore } from "@/stores";
import { ResourceName } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useDeleteUser = () => {
  const notify = useNotify();
  const { closeModal } = useUIStore();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (body: DeleteUserRequest) => {
      closeModal();
      return UsersApi.deleteUser(body);
    },
    onError: (error) => {
      notify(error, { type: "error" });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ResourceName.USERS] });
      notify("User deleted!", { type: "warning" });
    },
  });

  return { deleteUser: mutate, isDeleteUserLoading: isPending };
};
